export default __webpack_public_path__ + "static/media/price_bg.dffe5227.png";